<template>
    <component :is="page ? 'div' : 'a-modal'" v-bind="page ? {} : modalProps" @cancel="$emit('close')">
        <div class="plm-modal" :class="{ 'plm-page': page }">
            <div class="plm-head" v-if="!page">
                <div>
                    <h3>Histórico de alterações</h3>
                    <div class="plm-sub">{{ product.pro_descricao }}</div>
                </div>
                <a-tooltip title="Fechar">
                    <a-button class="plm-x" @click="$emit('close')">
                        <span class="material-icons-outlined">close</span>
                    </a-button>
                </a-tooltip>
            </div>

            <div class="plm-body">
                <a-table
                    size="small"
                    :columns="columns"
                    :data-source="logs"
                    :row-key="(record, index) => index"
                    :loading="loading"
                    :pagination="{ pageSize: 20, size: 'small' }"
                    :scroll="{ x: 'max-content' }"
                    :locale="{ emptyText: 'Sem registro.' }"
                >
                    <template slot="date" slot-scope="text">{{ formatDate(text) }}</template>
                    <template slot="action" slot-scope="text">
                        <a-tag :color="text === 'create' ? 'green' : 'blue'">{{ text }}</a-tag>
                    </template>
                    <template slot="value" slot-scope="text">{{ text || "--" }}</template>
                </a-table>
            </div>

            <div class="plm-foot" v-if="!page">
                <a-button @click="$emit('close')">Fechar</a-button>
            </div>
        </div>
    </component>
</template>

<script>
import moment from "moment";
import AuditService from "@/services/AuditService.js";
import ErrorHandlerService from "@/services/ErrorHandlerService";

export default {
    name: "ProductLogV2Modal",
    props: {
        product: { type: Object, required: true },
        page: { type: Boolean, default: false },
    },
    computed: {
        modalProps() {
            return {
                visible: true,
                width: "70vw",
                footer: null,
                closable: false,
                destroyOnClose: true,
                centered: true,
                wrapClassName: "plm-wrap",
            };
        },
    },
    data() {
        return {
            service: new AuditService(),
            loading: false,
            logs: [],
            columns: [
                { title: "Data", dataIndex: "updated_at", key: "updated_at", scopedSlots: { customRender: "date" } },
                { title: "Usuário", dataIndex: "usu_login", key: "usu_login" },
                { title: "Tipo", dataIndex: "action", key: "action", align: "center", scopedSlots: { customRender: "action" } },
                { title: "Campo", dataIndex: "field", key: "field", scopedSlots: { customRender: "value" } },
                { title: "Dado antigo", dataIndex: "old", key: "old", scopedSlots: { customRender: "value" } },
                { title: "Dado novo", dataIndex: "newValue", key: "newValue", scopedSlots: { customRender: "value" } },
            ],
        };
    },
    created() {
        this.load();
    },
    methods: {
        formatDate(value) {
            return value ? moment(value).format("DD/MM/YYYY") : "--";
        },
        parseEntry(entry) {
            if (entry.action === "create") return [entry];
            return String(entry.details || "")
                .split("Field:")
                .slice(1)
                .map((chunk) => ({
                    ...entry,
                    field: chunk.split(" -")[0].trim(),
                    old: (chunk.split("Old Value: ")[1] || "").split(",")[0],
                    newValue: (chunk.split("New Value: ")[1] || "").split("\n")[0],
                }))
                .filter((row) => row.old !== row.newValue);
        },
        load() {
            this.loading = true;
            this.service
                .getAudit(this.product.pro_id)
                .then(({ data }) => {
                    this.logs = (data.data || []).reduce((rows, entry) => rows.concat(this.parseEntry(entry)), []);
                })
                .catch((error) => {
                    ErrorHandlerService.handle(error, this.$store);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.plm-modal {
    max-height: 88vh;
    background: #fff;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    &.plm-page {
        max-height: none;
        overflow: visible;

        .plm-body {
            overflow: visible;
            padding: 0;
            border-top: none;
        }
    }
}
.plm-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 18px 20px 14px;

    h3 {
        font-size: 16px;
        font-weight: 600;
        color: #262626;
    }
}
.plm-sub {
    font-size: 13px;
    color: #8c8c8c;
    margin-top: 2px;
}
.plm-x.ant-btn,
.plm-x.ant-btn:focus,
.plm-x.ant-btn:active {
    width: 28px;
    height: 28px;
    padding: 0;
    border: none;
    background: none;
    border-radius: 6px;
    color: #8c8c8c;
    box-shadow: none;
    display: flex;
    align-items: center;
    justify-content: center;
}
.plm-x.ant-btn:hover {
    background: #f0f0f0;
    color: #262626;
}
.plm-body {
    flex: 1;
    overflow-y: auto;
    padding: 4px 20px 12px;
    border-top: 1px solid #f0f0f0;
    min-height: 200px;
}
.plm-foot {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding: 14px 20px;
    border-top: 1px solid #f0f0f0;
}
</style>

<style lang="scss">
.plm-wrap {
    .ant-modal {
        min-width: 560px;
        max-width: 95vw;
    }

    .ant-modal-content {
        padding: 0;
        border-radius: 10px;
        overflow: hidden;
    }

    .ant-modal-body {
        padding: 0;
    }
}
</style>
